/* IdenScan training booking — step 3 guided intake flow.
   Shows one question at a time inside the existing step 3 (no page reload, no extra
   Shopify section). Answers stay as normal form inputs, so the existing booking JS
   reads them into the payload. Progressive enhancement: without JS every question is
   visible and answerable. */
(function () {
  'use strict';

  var flows = document.querySelectorAll('[data-intake-flow]');
  if (!flows.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(flows, function (flow) {
    var cards = Array.prototype.slice.call(flow.querySelectorAll('[data-intake-q]'));
    if (!cards.length) return;

    var done = flow.querySelector('[data-intake-done]');
    var total = cards.length;
    var countEl = flow.querySelector('[data-intake-count]');
    var totalEl = flow.querySelector('[data-intake-total]');
    var fill = flow.querySelector('[data-intake-fill]');
    var index = 0;
    var autoTimer = null;

    if (totalEl) totalEl.textContent = String(total);
    flow.classList.add('is-enhanced');

    function clearAuto() { if (autoTimer) { window.clearTimeout(autoTimer); autoTimer = null; } }

    function updateProgress(shown, completed) {
      var n = completed ? total : (shown + 1);
      if (countEl) countEl.textContent = String(n);
      if (fill) fill.style.width = Math.round((n / total) * 100) + '%';
    }

    function focusTitle(card) {
      var title = card.querySelector('.isb-intake__title');
      // Move focus for keyboard/screenreader users, but do NOT force a scroll:
      // every question renders in the same stage slot, so it is already in view.
      // preventScroll avoids a visible jump on each advance on mobile.
      if (title && typeof title.focus === 'function') { try { title.focus({ preventScroll: true }); } catch (e) { title.focus(); } }
    }

    function show(i, focus) {
      clearAuto();
      index = Math.max(0, Math.min(cards.length - 1, i));
      cards.forEach(function (card, ci) { card.hidden = ci !== index; });
      if (done) done.hidden = true;
      updateProgress(index, false);
      if (focus) focusTitle(cards[index]);
    }

    function finish() {
      clearAuto();
      cards.forEach(function (card) { card.hidden = true; });
      if (done) {
        done.hidden = false;
        var heading = done.querySelector('h4');
        if (heading && typeof heading.focus === 'function') { try { heading.focus(); } catch (e) {} }
      }
      updateProgress(total - 1, true);
    }

    // Reveal any conditional block whose trigger field matches; returns true if a block is shown.
    function evalConds(card) {
      var conds = card.querySelectorAll('[data-intake-cond]');
      var anyVisible = false;
      Array.prototype.forEach.call(conds, function (cond) {
        var field = cond.getAttribute('data-cond-field');
        var values = (cond.getAttribute('data-cond-values') || '').split('|');
        var checked = card.querySelector('[name="' + field + '"]:checked');
        var match = !!checked && values.indexOf(checked.value) !== -1;
        cond.hidden = !match;
        if (match) anyVisible = true;
      });
      return anyVisible;
    }

    function nextFrom(card) {
      var i = cards.indexOf(card);
      if (i === cards.length - 1) finish();
      else show(i + 1, true);
    }

    // "Anders" free-text toggles.
    Array.prototype.forEach.call(flow.querySelectorAll('[data-intake-other-toggle]'), function (label) {
      var targetName = label.getAttribute('data-intake-other-toggle');
      var input = label.querySelector('input');
      var field = flow.querySelector('[data-intake-other="' + targetName + '"]');
      if (!input || !field) return;
      var sync = function () {
        field.hidden = !input.checked;
        if (!input.checked) { var text = field.querySelector('input'); if (text) text.value = ''; }
      };
      input.addEventListener('change', sync);
      sync();
    });

    // A checkbox marked as exclusive cannot be combined with another answer in
    // the same group. Programmatic unchecks emit `change` so existing "Anders"
    // toggles, visual state and booking-state listeners stay in sync.
    flow.addEventListener('change', function (event) {
      var changed = event.target;
      if (!changed || changed.type !== 'checkbox' || !changed.checked) return;
      var name = changed.getAttribute('name');
      if (!name) return;
      var group = flow.querySelectorAll('input[type="checkbox"][name="' + name + '"]');
      var exclusive = changed.hasAttribute('data-exclusive-choice');
      Array.prototype.forEach.call(group, function (input) {
        if (input === changed || !input.checked) return;
        if (exclusive || input.hasAttribute('data-exclusive-choice')) {
          input.checked = false;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    // Conditional reveals + optional auto-advance for single-choice cards without a follow-up.
    cards.forEach(function (card) {
      var auto = card.hasAttribute('data-intake-auto');
      card.addEventListener('change', function (event) {
        if (!event.target || event.target.type !== 'radio') return;
        var revealed = evalConds(card);
        if (auto && !revealed) {
          clearAuto();
          // Short pause purely so the tapped answer is visibly selected before we
          // advance. Kept ≤100ms so single-choice questions feel instant on mobile.
          autoTimer = window.setTimeout(function () { nextFrom(card); }, reduceMotion ? 0 : 100);
        }
      });
      evalConds(card);
    });

    flow.addEventListener('click', function (event) {
      var next = event.target.closest ? event.target.closest('[data-intake-next]') : null;
      var prev = event.target.closest ? event.target.closest('[data-intake-prev]') : null;
      var edit = event.target.closest ? event.target.closest('[data-intake-edit]') : null;
      if (next) { event.preventDefault(); nextFrom(next.closest('[data-intake-q]')); }
      else if (prev) { event.preventDefault(); show(index - 1, true); }
      else if (edit) { event.preventDefault(); show(0, true); }
    });

    show(0, false);
  });
})();
